import { styled as e } from "@lokalise/styled";
import { typography as i, spacing as r, value as o } from "../../utils/theme/index.js";
import { outlineStyle as a } from "../../utils/styles/outlineStyle.js";
const l = e.label`
	${i("body.small.default")};
	display: grid;
	align-items: center;
	grid-template-columns: 1em auto;
	gap: ${r(1)};
	/* Required because of global styles applied by bootstrap */
	margin: 0;
	&:has(input:disabled),
	&:has(input:disabled) * {
		cursor: not-allowed;
	}
`, c = e.input`
	// Double selector specificity to fight bootstrap global styles
	&& {
		appearance: none;
		margin: 0;
		font: inherit;
		color: currentColor;
		width: 14px;
		height: 14px;
		background-color: ${o("color.background.input.default")};
		border: 1px solid ${o("color.border.input.default")};
		border-radius: 50%;

		// To align the :before to the horizontal and vertical center
		display: grid;
		place-content: center;
	}

	&&:focus {
		outline: none;
	}
	/*
    * Focus outline is only visible when user is using keyboard. This behavior matches native radio behavior.
    */
	&&:focus-visible {
		${a}
	}

	&&:hover,
	&&:checked:hover:not(:disabled) {
		border-color: ${o("color.background.action.primary.hover")};
	}

	&&:checked:hover::before {
		background-color: ${o("color.background.action.primary.hover")};
	}

	&&:checked {
		border-color: ${o("color.background.action.primary.default")};
	}

	&&:disabled {
		border-color: ${o("color.border.disabled")};
	}

	// Styling for the inner dot
	&&::before {
		// Has to be a round number to be able to nicely align within the circle.
		// Numbers like 7.5px are not properly centered on some displays.
		--size: 8px;
		content: '';
		width: var(--size);
		height: var(--size);
		border-radius: 50%;
		transform: scale(0);
		transition: 100ms transform ease-in-out;
		background-color: ${o("color.background.action.primary.default")};
	}

	&&:checked::before {
		transform: scale(1);
	}

	&&:checked:disabled::before {
		background-color: ${o("color.border.disabled")};
	}
`, s = e.div`
	width: 100%;
`, b = e.div`
	display: grid;
	gap: ${r(3)};
`, u = e.div`
	padding-top: ${r(3)};
`;
export {
  c as Input,
  l as Label,
  s as RadioGroupContainer,
  u as RadioGroupErrorContainer,
  b as StyledRadioGroup
};
//# sourceMappingURL=styles.js.map
